import styled from '@emotion/styled'
import { BackdropModal } from '@helpers/styles'

const BackdropWithModalStyles = styled(BackdropModal)`
	${({ theme }) => `
        .modal-title {
            padding-top: 32px;
            padding-bottom: 8px;
        }

        .section-title {
            color: ${theme.palette.fonts.secondary};
            font-size: 1rem;
            padding: 16px 0;
            margin-bottom: 16px;
        }

        .form-label {
            color: ${theme.palette.fonts.darkGrey};
            font-size: 0.875rem;
        }

        .form-input {
            width: 400px;
            font-size: 0.875rem;
            padding: 0;
            margin-bottom: 16px;
        }

        .modal-action-part {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            padding-top: 12px;

            .modal-cancel-button {
                margin-right: 10px;
            }
        }
    `}
`

export { BackdropWithModalStyles }
